import { IconComponent } from './types';

const BetweenRowIcon: IconComponent = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 6 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_615_6417"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="6"
      height="6"
    >
      <rect width="6" height="6" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_615_6417)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 6L0 6L0 5.5L6 5.5V6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 1L0 1L0 0.5L6 0.5V1Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.12729 4.10607C3.057 4.16464 2.94303 4.16464 2.87273 4.10607L1.72722 3.15147C1.65693 3.09289 1.65693 2.99792 1.72722 2.93934C1.79751 2.88076 1.91148 2.88076 1.98178 2.93934L2.82001 3.63787L2.82001 1L3.18001 1L3.18001 3.63787L4.01825 2.93934C4.08854 2.88076 4.20251 2.88076 4.2728 2.93934C4.3431 2.99792 4.3431 3.09289 4.2728 3.15147L3.12729 4.10607Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default BetweenRowIcon;
